import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Modal, Button, message } from "antd";
import CloseButton from "../../Common/CloseButton/CloseButton";
import restaurantSchemaActions from "../../../redux/restaurantSchema/actions";
import "./index.css";

const { createNewReservationTable } = restaurantSchemaActions;

// Shape values match backend ReservationTableShape enum
const OBJECT_TYPES = [
  { shape: 4, name: "Бар", icon: "🍸" },
  { shape: 5, name: "Стена", icon: "🧱" },
  { shape: 6, name: "Растение", icon: "🌿" },
  { shape: 7, name: "Вход", icon: "🚪" },
  { shape: 8, name: "Сцена", icon: "🎤" },
  { shape: 9, name: "DJ Пулт", icon: "🎧" },
];

const AddObjectModal = ({ open, setOpen, regionId }) => {
  const dispatch = useDispatch();
  const [selected, setSelected] = useState(null);

  const handleAdd = () => {
    if (selected === null) {
      message.warning("Моля изберете тип обект");
      return;
    }
    const objType = OBJECT_TYPES.find((o) => o.shape === selected);

    dispatch(
      createNewReservationTable({
        tableName: objType.name,
        touchSaleTableId: null,
        regionId: regionId,
        x: 600,
        y: 300,
        direction: 0,
        scale: 1.0,
        shape: objType.shape,
        seatsCount: 0,
        organizationId: parseInt(localStorage.getItem("organizationId")),
      })
    );

    setOpen(false);
    setSelected(null);
    message.success(`Добавен обект: ${objType.name}`);
  };

  return (
    <Modal
      closeIcon={<CloseButton />}
      title="Добави обект"
      open={open}
      onCancel={() => {
        setOpen(false);
        setSelected(null);
      }}
      footer={null}
      className="restaurant-scheme-table-modal"
    >
      <div className="add-object-grid">
        {OBJECT_TYPES.map((obj) => (
          <div
            key={obj.shape}
            className={`add-object-card ${selected === obj.shape ? "selected" : ""}`}
            onClick={() => setSelected(obj.shape)}
          >
            <div className={`add-object-card-icon shape-${obj.shape}`}>
              {obj.icon}
            </div>
            <span className="add-object-card-name">{obj.name}</span>
          </div>
        ))}
      </div>
      <div className="restaurant-scheme-edit-table-modal-footer">
        <Button type="primary" onClick={handleAdd} disabled={selected === null}>
          Добави
        </Button>
      </div>
    </Modal>
  );
};

export { OBJECT_TYPES };
export default AddObjectModal;
